export default __webpack_public_path__ + "static/media/banner_faq_2.66fb858f.png";